export default __webpack_public_path__ + "assets/f97f9f482c2d83f6ff379d4dbb969aed.svg";